import React, { ComponentType } from 'react';
import ErrorBoundary from './index';

/**
 * Higher-order component that wraps a component with an ErrorBoundary
 */
function withErrorBoundary<P extends object>(
  WrappedComponent: ComponentType<P>,
  componentName?: string,
  fallback?: React.ReactNode,
) {
  const WithErrorBoundaryComponent = (props: P) => (
    <ErrorBoundary
      componentName={
        componentName || WrappedComponent.displayName || WrappedComponent.name
      }
      fallback={fallback}
    >
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );

  WithErrorBoundaryComponent.displayName = `withErrorBoundary(${
    componentName || WrappedComponent.displayName || WrappedComponent.name
  })`;

  return WithErrorBoundaryComponent;
}

export default withErrorBoundary;
